<template>
  <div class="more-style">
    <el-input v-if="showMoreTextInput" v-model="$$FormData.more_text" placeholder="输入更多文字" />
    <en-link-selector
      v-model="$$FormData.more_link"
      :domain="$$Domain"
      :client-type="clientType"
      :decor-type="decorType"
    />
  </div>
</template>

<script>
import { clientType, decorType } from '@/utils/decor-types'

export default {
  name: 'TitleTextMoreStyle',
  computed: {
    showMoreTextInput() {
      return [1, 2].includes(this.$$FormData.more_style)
    }
  },
  data() {
    return {
      clientType,
      decorType
    }
  }
}
</script>

<style lang="scss" scoped>
.more-style {
  margin-top: 12px;
  .el-input:first-child {
    margin-bottom: 12px;
  }
}
</style>
